var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-user position-relative d-inline-block mx-auto mb-4"},[_c('img',{staticClass:"rounded-circle avatar-xl img-thumbnail user-profile-image",attrs:{"src":_vm.profilePic,"alt":"user-profile-image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }